import React from "react";
import {
  Datagrid,
  Edit,
  List,
  TextField,
  ReferenceField,
  DateTimeInput,
  SimpleForm,
  ReferenceInput,
  Create,
  AutocompleteInput,
  FunctionField,
} from "react-admin";
import {userRenderer} from "./User";

export const SubscriptionList = (props) => {
  return (
    <List {...props}>
      <Datagrid rowClick="edit">
        <TextField source="id" />
        <TextField source="startDate" />
        <TextField source="purchaseDate" />
        <TextField source="expiryDate" />


        <ReferenceField label="User" reference="User" source="user.id">
          
          <FunctionField
          label="User"
          render={userRenderer}
        />
        </ReferenceField>
      </Datagrid>
    </List>
  );
};

const SubscriptionFormInput = ({ ...props }) => {
  return (
    <SimpleForm {...props} warnWhenUnsavedChanges>
      
      <DateTimeInput source="startDate" />
      <DateTimeInput source="purchaseDate" />

      <DateTimeInput source="expiryDate" />
 
      <ReferenceInput
      label="User"
      source="user.id"
      reference="User"
      sort={{ field: "email", order: "ASC" }}
      perPage={10}
      filterToQuery={(searchText) => ({
        OR: [{ email_contains: searchText }],
      })}
    >
      <AutocompleteInput optionText="email" />
    </ReferenceInput>
    </SimpleForm>
  );
};
export const SubscriptionEdit = (props) => (
  <Edit {...props}>
    <SubscriptionFormInput />
  </Edit>
);
export const SubscriptionCreate = (props) => (
  <Create {...props}>
    <SubscriptionFormInput />
  </Create>
);
